import {
  COMPLIANCE_GET_POSTS_ATTEMPT,
  COMPLIANCE_GET_POSTS_SUCCESS,
  COMPLIANCE_GET_POSTS_FAILURE,
  COMPLIANCE_GET_UPDATES_ATTEMPT,
  COMPLIANCE_SET_POSTS,
  COMPLIANCE_SET_UPDATES,
  SHOW_POSTER,
  COMPLIANCE_SHOW_LOADING
} from './actionTypes'

export const getPosts = () => ({
  type: COMPLIANCE_GET_POSTS_ATTEMPT,
  meta: {},
  payload: {}
})

export const getPostsFailure = () => ({
  type: COMPLIANCE_GET_POSTS_FAILURE,
  meta: {},
  payload: {}
})

export const getPostsSuccess = (data) => ({
  type: COMPLIANCE_GET_POSTS_SUCCESS,
  meta: {},
  payload: { data }
})

export const getUpdates = () => ({
  type: COMPLIANCE_GET_UPDATES_ATTEMPT,
  meta: {},
  payload: {}
})

export const hidePoster = (poster) => ({
  type: SHOW_POSTER,
  poster: null
})

export const setPosts = (data) => ({
  type: COMPLIANCE_SET_POSTS,
  meta: {},
  payload: { data }
})

export const setShipments = (data) => ({
  type: COMPLIANCE_SET_SHIPMENTS,
  meta: {},
  payload: { data }
})

export const setUpdates = (data) => ({
  type: COMPLIANCE_SET_UPDATES,
  meta: {},
  payload: { data }
})

export const showPoster = (poster) => ({
  type: SHOW_POSTER,
  poster
})

export const setLoading = (data) => ({
  type: COMPLIANCE_SHOW_LOADING,
  meta: {},
  payload: data
})

export default {
  getPosts,
  getPostsFailure,
  getPostsSuccess,
  getUpdates,
  hidePoster,
  setPosts,
  setShipments,
  setUpdates,
  showPoster,
  setLoading
}
